<template>
  <div v-if="ngpToggleVisible" class="absolute inset-x-5 top-5">
    <div class="mx-auto flex w-full max-w-container justify-end">
      <gp-btn size="sm" :label="t('ngp/header/legacy_button')" @click="toggleNgp()" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Only show ngp toggle if the beta cookie is set
import { GpBtn } from "@gportal/uikit";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useServiceStore } from "../../store/service";
import { cookies } from "../../util/route";

const { t } = useI18n();

const service = useServiceStore();
const ngpToggleVisible = computed(() => !!cookies().get("ngp_beta") && service.ctx?.gameProfile?.isBeta);

const router = useRouter();

/**
 * Removes the ngp beta cookie and reloads the page
 * @param _ Event
 */
function toggleNgp() {
  document.cookie = "ngp_beta=0; path=/";
  const newUri = router.resolve({ params: { tabSegments: [] } }).fullPath;
  window.location.replace(newUri);
}
</script>
